'use client';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

import { useEffect, useState } from 'react'

export default function Error({ error }) {
  const [errorDetails, setErrorDetails] = useState({
    statusCode: 500,
    message: "An unexpected error occurred"
  })
  
  useEffect(() => {
    // Extract error code from error object if available
    if (error.statusCode) {
      setErrorDetails({
        statusCode: error.statusCode,
        message: error.message || getDefaultMessageForCode(error.statusCode)
      })
    }
  }, [error])

  // Helper function to get default messages for common status codes
  function getDefaultMessageForCode(code) {
    const messages = {
      400: "Bad Request",
      401: "Unauthorized",
      403: "Forbidden",
      404: "Not Found",
      500: "Server Error",
      503: "Service Unavailable"
    }
    return messages[code] || "Unknown Error"
  }

  return (
    <div className={"page"}>
          <title>{errorDetails.statusCode} {errorDetails.message}</title>
          <Header />
          <main className={"main"}>
            <div className="pageCategory">Error</div>
            <div className="pageTitle">{errorDetails.statusCode} {errorDetails.message}</div>
            <div className="pageBody">
              <p>Sorry, there was an issue accessing this page.</p>
            </div>
          </main>
          <Footer />
        </div>
  )
}